import * as React from "react";
import {Display} from "../../components/Display";
import {Button} from "@vebox/etui-core";

export type VeboxDrawerProps = {
    header?: JSX.Element
    closedHeader?: JSX.Element
    onToggle?: (open: boolean) => void
    defaultOpen?: boolean
    closable: boolean
}

export const VeboxDrawer: React.FC<React.HTMLProps<HTMLDivElement> & VeboxDrawerProps> = (props) => {

    const [open, setOpen] = React.useState<boolean>(props.defaultOpen ?? false);

    React.useEffect(() => {
        if (typeof props.open === "boolean") {
            setOpen(props.open);
        }
    }, [props.open]);

    const close = () => {
        if (props.onToggle) {
            props.onToggle(!open)
        } else {
            setOpen(!open);
        }
    }

    return (
        <div {...{
            ...props,
            header: undefined
        }} className={`flx-col drawer ${open ? "open-drawer" : ""} ${props.className}`}
        >
            <header className={`${open ? 'flx-row flx-space-between' : 'flx-col'}`}>
                <Display isVisible={open}>
                    {props.header}
                </Display>
                {props?.closable && (
                    <Button onClick={close}>
                        <div className={`menuTabImg ${!open ? 'menuTabImgClosed' : ""}`}></div>
                    </Button>)}
                {!props?.closable && !open && (
                    <Button onClick={close}>
                        <div className={`menuTabImg ${!open ? 'menuTabImgClosed' : ""}`}></div>
                    </Button>
                )}
                <Display isVisible={!open && props.closedHeader}>
                    {props.closedHeader}
                </Display>
            </header>
            <Display isVisible={open}>
                {props.children}
            </Display>
        </div>
    );
}